import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { TranslateService } from '@ngx-translate/core';
import { TeamMessageService } from '../service/team-message.service';
import {
  Router,
  RouterLink,
  RouterOutlet
} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import {ThemePalette} from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {
  MatDialog  
} from '@angular/material/dialog';
import { TeamMessageDetailDialogComponent } from '../team-message-detail-dialog/team-message-detail-dialog.component';
import { TeamMessageAttachmentComponent } from '@app/team-message-attachment/team-message-attachment.component';
import { TranslateModule } from '@ngx-translate/core';
import { TeamMessageQuitComponent } from '@app/team-message-quit/team-message-quit.component';
@Component({
  selector: 'app-team-message-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatCardModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatIconModule,
    RouterLink,
    MatButtonModule,
    TeamMessageDetailDialogComponent,
    TranslateModule,
  ],
  templateUrl: './team-message-detail.component.html',
  styleUrl: './team-message-detail.component.css'
})
export class TeamMessageDetailComponent {
  color : ThemePalette = 'accent';
  isLoading = false;
  alreadyRead = '';
  markAsRead = '';
  apexId!:string;
  browserLangToUse = '';
  constructor(
    private route: ActivatedRoute,    
    private teamMessageService: TeamMessageService,
    private location: Location,
    translate: TranslateService,
    public dialog: MatDialog, 
  ) {
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse);
    this.browserLangToUse = browserLangToUse;
    translate.get('ml_151123').subscribe((res: string) => {
      this.alreadyRead = res;      
    });
    translate.get('ml_151124').subscribe((res: string) => {
      this.markAsRead = res;      
    });
  }

  ngOnInit(): void {
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      console.log(`team-message not override apex id`);
      this.apexId = localStorage.getItem("apexid")!;
    } 
    else{
      console.log(`team-message override apex id`);
      let overrideObject = JSON.parse(overrideObjectString);
      this.apexId = overrideObject.apexid;
    }
    this.getDetail();
  }
  messageId = 0;
  driverId = 0;
  sender = '';
  createTime = '';
  readTime = '';
  disableButton = false;
  getAttachmentS3Url = '';
  getDetail(): void {
    const message_id = Number(this.route.snapshot.paramMap.get('message_id'));
    this.messageId = message_id;
    
    const driver_id = Number(this.route.snapshot.paramMap.get('driver_id'));
    this.driverId = driver_id;
    const sender = this.route.snapshot.paramMap.get('sender');
    if(sender !== null){
      this.sender = sender;
    }
    const time = this.route.snapshot.paramMap.get('time');
    if(time !== null){
      this.createTime = this.formatDateTime(time);
    }
    const readTime = this.route.snapshot.paramMap.get('readTime');
    // console.log(readTime);
    if(readTime !== null){
      if(readTime !== 'null'){
        this.readTime = readTime;
        this.disableButton = true;
      }
      
    }
    const s3Url = this.route.snapshot.paramMap.get('getAttachmentS3Url');
    if(s3Url !== null){
      this.getAttachmentS3Url = s3Url;
      console.log(s3Url);
    }
    console.log(message_id);
    
    this.pageInitialization(message_id);
  }

  teamMessageArray!: any[];
  currentteamMessage!: any;
  private pageInitialization(messageId:number): void {
    this.isLoading = true;
    this.teamMessageService.getTeamMessageByTeamMessageId(messageId.toString()).subscribe(responseTeamMessage =>{
      this.currentteamMessage = responseTeamMessage;
      this.currentteamMessage.getAttachmentS3Url = this.getAttachmentS3Url;
      this.isLoading = false;
    });

    
  }

  checkIfAttachmentExist():boolean{
    let hasAttachment = true;
    if(this.currentteamMessage.attachment === '' || this.currentteamMessage.attachment === null){
      hasAttachment = false;
    }
    return hasAttachment;
  }
  
  public markRead() {
    const timeout = 2000;
    const dialogRef = this.dialog.open(TeamMessageDetailDialogComponent);
    
    let readObject: any = {teammessage_id: this.messageId, Driver_Id: this.driverId, };
    this.teamMessageService.markReadTeamMessage(readObject).subscribe(responseTeamMessageObject => {      
      console.log(`team message mark read complete`);
      this.disableButton = true;
    });

    dialogRef.afterOpened().subscribe(_ => {      
      setTimeout(() => {
         dialogRef.close();
      }, timeout)
    })
  }

  public goBack() {
    console.log(`team message detail, go back`);
    if(this.disableButton){   
      console.log(`team message detail, go back, already read`);
      // already read
      this.location.back();
    }
    else{      
      console.log(`team message detail, go back, not read`);
      // not read yet
      let readObject: any = {teammessage_id: this.messageId, Driver_Id: this.driverId, };
      const dialogRef = this.dialog.open(TeamMessageQuitComponent, {
        data: {
          readObject: readObject,
        },
      });

      dialogRef.afterClosed().subscribe(_ => {      
        this.location.back();
      });
    }
  }  

  backClicked() {
    this.location.back();
  }

  private formatDateTime(created_On: string): string {
    // throw new Error('Function not implemented.');
    // 2024-03-28T05:16:46.644514Z
    let formatedDateTime = '';
    let date = new Date(created_On);
    // 3/28/2024
    let datePart = date.toLocaleDateString();
    let timePart = date.toLocaleTimeString().replace(/(.*)\D\d+/, '$1');
    formatedDateTime = datePart + ' ' + timePart;
    return formatedDateTime;
  }

  urlify(text:string) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
  }

  addNewLine(test:string){
    return test.replace(new RegExp('\r?\n','g'), '<br />');
  }

  openDialog(teamMessage:any) {
    this.dialog.open(TeamMessageAttachmentComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        teamMessage: teamMessage,
      },
    });
  }

}
